import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { AuthenticationService } from '../providers/authentication/authenticationService';
import { GenericQueryParams, getParamsFromFilters } from '../utils/utils';
import { ConfigService } from '../providers/config/config.service';
export type GenericPaginatedDataType<T> = {
  values: T[];
  pages: number;
  elements: number;
};

export type Params =
  | HttpParams
  | {
      [param: string]: string | string[];
    };
@Injectable()
export class CommonService {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private configService: ConfigService
  ) {}

  public getData<T>(url: string, params?: Params): Observable<T> {
    let observable = this.http.get<T>(url, {
      ...this.getHttpOptions(),
      params,
    });
    return observable;
  }

  public getHttpOptions(): { headers: HttpHeaders } {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + this.authenticationService.token,
      }),
    };
    return httpOptions;
  }

  public getPaginatedQuery<T>(path: string, params: GenericQueryParams): Observable<T> {
    const baseUrl = this.configService.getUrl() + path;
    const { pageNumber } = params.pagination;
    const { sorting, search } = params;
    const url = baseUrl + '/page/' + pageNumber;
    const _params = getParamsFromFilters({
      sorting,
      search,
    });

    return this.http.get<T>(url, {
      ...this.getHttpOptions(),
      params: _params,
    });
  }

  public editData<T>(url: string, data: object): Observable<T> {
    let response = this.http.put<T>(url, JSON.stringify(data), this.getHttpOptions());
    return response;
  }

  public createData<T>(url: string, data: object): Observable<T> {
    let response = this.http.post<T>(url, JSON.stringify(data), this.getHttpOptions());
    return response;
  }

  public deleteData<T>(url: string): Observable<T> {
    let response = this.http.delete<T>(url, this.getHttpOptions());
    return response;
  }
}



// WEBPACK FOOTER //
// ./src/services/common.service.ts